export const LONDON_COORDINATES = {
  lat: 51.509865,
  lng: -0.118092,
}

export const UK_COORDINATES = {
  lat: 53.8584624,
  lng: -1.3298334,
}
